module.exports = __webpack_public_path__ + "static/media/timecard.6f45c7ea.svg";